/**
 * Match store — 对局结果在 GameScene → ResultScene 之间的传递通道。
 * （棋局状态以 CheckersGame 为唯一权威源，此处只承载终局快照。）
 */
import { atom } from 'nanostores';
import type { Mode } from '@shared/config/theme';
import type { Standing } from '@shared/net/messages';
import type { ComboStats } from '@shared/game/combo';

export interface MatchResult {
  /** Null when the match was aborted（联机终止局）。 */
  winnerSeat: number | null;
  winnerName: string;
  winnerColor: string;
  /** seat order of the match (2/3/4/6). */
  seats: readonly number[];
  mode: Mode;
  /** Total atomic moves executed. */
  moves: number;
  /** Completed full rounds (turn passes ÷ seats). */
  rounds: number;
  /** 联机模式：本家座位（胜负判词按此比较，而非固定 seat 0）。 */
  yourSeat?: number;
  /** 联机模式：服务端最终排名。 */
  standings?: Standing[];
  /** 联机终局原因（camp_complete / last_standing / aborted）。 */
  reason?: string;
  /** 本地模式：各座 combo 记帐（v2.1；联机走 standings 的服务端字段）。 */
  combos?: ({ seat: number } & ComboStats)[];
}

export const $matchResult = atom<MatchResult | null>(null);
